export class SmTableColumnStatus {
    columnId: string;
    filter: any; 
    sort: "asc" | "desc";
    sortIndex: number;
    hide: boolean;
    width: number;
    flex: number;
}
